var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.716 1.14.306 4.72A1.062 1.062 0 0 0 0 5.504c0 .295.102.545.307.75l3.409 3.613a1 1 0 0 0 .733.307 1 1 0 0 0 .733-.307c.204-.204.307-.465.307-.784 0-.318-.103-.58-.307-.784L3.545 6.595h7.398a.994.994 0 0 0 .75-.324c.205-.216.307-.472.307-.767 0-.296-.102-.551-.307-.767a.994.994 0 0 0-.75-.324H3.545l1.67-1.705c.205-.204.308-.466.308-.784s-.103-.58-.307-.784a1.02 1.02 0 0 0-.75-.307 1.02 1.02 0 0 0-.75.307z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.d2f412d3b64b7dce4d67b837145af925.svg";
export { ForwardRef as ReactComponent };